"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const In = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 900 600", ...props },
    react_1.default.createElement("path", { fill: "#f93", d: "M0 0h900v200H0z" }),
    react_1.default.createElement("path", { fill: "#fff", d: "M0 200h900v200H0z" }),
    react_1.default.createElement("path", { fill: "#128807", d: "M0 400h900v200H0z" }),
    react_1.default.createElement("g", { transform: "translate(450 300)" },
        react_1.default.createElement("circle", { r: 92.5, fill: "#008" }),
        react_1.default.createElement("circle", { r: 80, fill: "#fff" }),
        react_1.default.createElement("circle", { r: 16, fill: "#008" }),
        react_1.default.createElement("g", { id: "in_svg__d" },
            react_1.default.createElement("g", { id: "in_svg__c" },
                react_1.default.createElement("g", { id: "in_svg__b" },
                    react_1.default.createElement("g", { id: "in_svg__a", fill: "#008" },
                        react_1.default.createElement("circle", { r: 3.5, transform: "rotate(7.5 -40 610.282)" }),
                        react_1.default.createElement("path", { d: "m0 80 3-48-2-16.031V15h-2v.969L-3 32l3 48z" })),
                    react_1.default.createElement("use", { xlinkHref: "#in_svg__a", transform: "rotate(15)" })),
                react_1.default.createElement("use", { xlinkHref: "#in_svg__b", transform: "rotate(30)" })),
            react_1.default.createElement("use", { xlinkHref: "#in_svg__c", transform: "rotate(60)" })),
        react_1.default.createElement("use", { xlinkHref: "#in_svg__d", transform: "rotate(120)" }),
        react_1.default.createElement("use", { xlinkHref: "#in_svg__d", transform: "rotate(-120)" }))));
exports.default = In;
//# sourceMappingURL=In.js.map